






























import { defineComponent, PropType, computed, useContext } from '@nuxtjs/composition-api';
import AppImage from '~/components/partials/App/AppImage.vue';
import { BOTTLE_200, BOTTLE_250 } from '~/constants/profilesForImage';
import { nonNullable } from '~/utils';
import { ProductListItem } from '~/types/modules/product';

export default defineComponent({
  components: {
    AppImage,
  },
  props: {
    labelsOnImage: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object as PropType<ProductListItem>,
      required: true,
    },
  },
  setup(props) {
    const { i18n } = useContext();

    const labelsOnImages = computed(() => {
      const { is_free_shipping, discount_rate } = props.item;
      return [
        is_free_shipping
          ? { category: 'freeShipping', title: i18n.t('Common.productListItem.text.freeShipping').toString() }
          : null,
        discount_rate
          ? {
              category: 'discount',
              title: i18n.t('Common.productListItem.text.discount', { discountRate: discount_rate }).toString(),
            }
          : null,
      ].filter(nonNullable);
    });

    return {
      labelsOnImages,
      BOTTLE_200,
      BOTTLE_250,
    };
  },
});
